import React from 'react';
import { NavLink } from 'react-router-dom';

interface MainNavigationProps {
    isScrolled: boolean;
    isHomePage: boolean;
}

const MainNavigation: React.FC<MainNavigationProps> = ({ isScrolled, isHomePage }) => {
    return (
        <div className="hidden lg:flex 2xl:gap-24 gap-20 h-[90%] items-center ">
            <NavLink
                to="/products"
                className={({ isActive }) =>
                    `font-play text-xl 2xl:text-2xl rounded-xl 2xl:rounded-2xl cursor-pointer font-bold px-4 2xl:px-6 h-full flex items-center hover:underline hover:decoration-solid   transition duration-300 ease-in-out ${isActive ? 'underline decoration-solid' : ''} ${isScrolled ? 'text-[#273167]' : isHomePage ? 'text-white' : 'text-[#273167]'}`
                }
            >
                Проекты
            </NavLink>
            {/* <NavLink
                to="/services"
                className={({ isActive }) =>
                    `font-play text-xl 2xl:text-2xl rounded-xl 2xl:rounded-2xl cursor-pointer font-bold px-4 2xl:px-6 h-full flex items-center transition duration-300 ease-in-out hover:underline hover:decoration-solid ${isActive ? 'underline decoration-solid' : ''} ${isScrolled ? 'text-[#273167]' : isHomePage ? 'text-white' : 'text-[#273167]'}`
                }
            >
                Продукты
            </NavLink> */}
            <NavLink
                to="/contacts"
                className={({ isActive }) =>
                    `font-play text-xl 2xl:text-2xl rounded-xl 2xl:rounded-2xl cursor-pointer font-bold px-4 2xl:px-6 h-full flex items-center transition duration-300 ease-in-out hover:underline hover:decoration-solid ${isActive ? 'underline decoration-solid' : ''} ${isScrolled ? 'text-[#273167]' : isHomePage ? 'text-white' : 'text-[#273167]'}`
                }
            >
                Контакты
            </NavLink>
        </div>
    );
};

export default MainNavigation;